// test1788
(1788 && 0);
